import isSameMonth from 'date-fns/is_same_month';
import addDays from 'date-fns/add_days';
import isBefore from 'date-fns/is_before';
import startOfMonth from 'date-fns/start_of_month';
import addMonths from 'date-fns/add_months';
import subMonths from 'date-fns/sub_months';
import isSameDay from 'date-fns/is_same_day';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import getMonth from 'date-fns/get_month';
import getDate from 'date-fns/get_date';
import getDay from 'date-fns/get_day';
import eachDay from 'date-fns/each_day';
import startOfWeek from 'date-fns/start_of_week';
import endOfWeek from 'date-fns/end_of_week';

export default class Calendar {
    /**
    * Create a new Calendar instance.
    */
    constructor(minimumStartDate) {
        this.minimumStartDate = minimumStartDate || new Date(2018, 8, 10);
        this.today = new Date();
        this.weekdays = null;
        this.data = [];
        this.month = new Date();
        this.day = null;
        this.time = null;
        this.activeHour = null;
        this.hours = [];
        this.activeDay = null;

        // Construct weekdays
        const now = new Date();
        const arr = eachDay(startOfWeek(now), endOfWeek(now));
        this.weekdays = [];

        for (let index = 0; index < arr.length; index++) {
            const d = arr[index];
            this.weekdays.push(format(d, 'dd'));
        }
        this.getAvailability();
    }

    /**
    * Fetches available times for the given day
    *
    * @param {object} dayObj
    */
    selectDay(dayObj) {
        if (!(dayObj.d && dayObj.available)) {
            return;
        }

        // Create an instance
        // Create an date-fns instance.
        // const day = parse(this.month).date(dayObj.d);
        const day = parse(dayObj.date);

        // If it's in the past, exit
        if (isBefore(day, this.today) || this.isBeforeStartDate(day)) {
            return;
        }

        if (this.activeDay) {
            this.activeDay.active = false;
        }

        this.activeDay = dayObj;
        this.activeDay.active = true;

        this.day = day;
        this.hours = [];

        this.time = null;
    }

    /**
     * Fetch the availability data for a given month
     */
    getAvailability() {
        this.data = [];

        this.days = [];

        // Get first day of month
        let day = startOfMonth(this.month);
        const currentMonth = this.month;
        const now = new Date();

        // Push a date while the day/month moment is current month
        do {
            // Create day moment
            this.days.push({
                d: getDate(day),
                past: isBefore(day, now),
                today: isSameDay(now, day),
                date: format(day, 'YYYY-MM-DD'),
                available: true,
            });

            // Move on to the next day using Moment.js logic
            day = addDays(day, 1);
        } while (getMonth(day) === getMonth(currentMonth));

        this.render();
    }

    /**
     * Navigate to the previous month
     */
    previousMonth() {
        const prevMonth = subMonths(this.month, 1);
        this.month = null;
        this.month = prevMonth;
        this.getAvailability();
    }

    /**
     * Navigate to the next month
     */
    nextMonth() {
        const nextMonth = addMonths(this.month, 1);
        this.month = null;
        this.month = nextMonth;
        this.getAvailability();
    }

    /**
     * Handle active day state
     *
     * @param  {Moment} dayObj
     * @return {Void}
     */
    handleActiveDay(dayObj) {
        if (this.activeDay) {
            this.activeDay.active = false;
        }

        this.activeDay = dayObj;
        this.activeDay.active = true;
    }

    /**
     * Render the show calendar
     */
    render() {
        const blocks = [];

        // Some padding at the beginning
        for (let p = 0; p < getDay(startOfMonth(this.month)); p++) {
            blocks.push({
                d: null,
            });
        }

        // Merge in the array of days
        blocks.push(...this.days);

        // Some padding at the end if needed
        if (blocks.length % 7) {
            for (let p = (7 - (blocks.length % 7)); p > 0; p--) {
                blocks.push({
                    d: null,
                });
            }
        }

        // Split the array into "chunks" of seven
        const rows = blocks.map((e, i) => (i % 7 === 0 ? blocks.slice(i, i + 7) : null)).filter((e) => e);

        this.data = rows;
    }

    inTodaysMonth() {
        return isSameMonth(this.month, this.today);
    }

    isBeforeStartDate(day) {
        return isBefore(day.date, this.minimumStartDate);
    }
}
